var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-App',[_c('navBarLeft',{ref:"navBarLeft"}),_c('v-main',{staticClass:"main-bcg",staticStyle:{"margin-left":"55px"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }